import React, { useState, useEffect } from "react";

import { getInfoTokensWithTotalGreaterThanZero, baseUrl, addOrUpdatePrazo } from '../../Services/tokens.service.js'

import LogoPush from "../../assets/web_not.svg";
import Edit from "../../assets/ic_edit.svg";
import styles from "./WebPushExclusion.module.css";

const WebPushExclusion = () => {
  const [isModalOpen, seiIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isItemValue, setItemValue] = useState(null);
  const [isTokens, setIsTokens] = useState([]);
  const [isTokenLabel, setIsTokenLabel] = useState('');
  const [isTokenDays, setIsTokenDays] = useState('');

  const getLabelFromUrl = (url) => {
    const item = baseUrl.find(item => item.url === url);
    return item && item.label ? item.label : '---';
  };

  useEffect(async () => {
    const inforTokens = await getInfoTokensWithTotalGreaterThanZero();
    setIsTokens(inforTokens);
  },[isTokenDays])

  const handleSaveButtonClick = async () => {
    const inputValueElement = document.getElementById('tokenDays').value;
    const editTokenDaysValue = document.getElementById('editTokenDays').innerHTML;

    await addOrUpdatePrazo(editTokenDaysValue, inputValueElement, handleSuccess, handleError);

    closeModal()
  };

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  const handleError = () => {
    setIsError(true);
  };

  const handleEdit = (item) => {
    openModal()

    setItemValue(`${item.id}`);
    setIsTokenLabel(getLabelFromUrl(item.token.url))
  };

  const openModal = () => {
    seiIsModalOpen(true);
  };

  const closeModal = () => {
    seiIsModalOpen(false);
    setIsTokenDays('')
  };

  const closeSucced = () => {
    setIsSuccess(false);
  };

  const handleInputTotalChange = (e) => {
    const inputValue = e.target.value.replace(/\D/g, '');
    const clampedValue = Math.min(180, Math.max(0, inputValue));

    setIsTokenDays(clampedValue);
  };  

  return (
    <>
      <main className="container">
        {isModalOpen && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <h1 className={styles.modalTitle}>{isTokenLabel}</h1>
              <p className={styles.modalText}>Em quantos dias os tokens dessa base devem ser excluídos?</p>
              <p className={styles.editMyElement} id="editTokenDays">{isItemValue}</p>
              <input
                className={styles.modalInput}
                id="tokenDays"
                type="text"
                value={isTokenDays}
                onChange={handleInputTotalChange}
                placeholder="0 a 180"
              />
              <div className={styles.modalBtns}>
                <button className={styles.modalBtnClose} onClick={closeModal}>Fechar</button>
                <button className={styles.modalBtnSave} onClick={handleSaveButtonClick}>Salvar</button>
              </div>
            </div>
          </div>
        )}
        {isSuccess && (
          <div className={styles.modalOverlay} onClick={closeModal}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <h1 className={styles.modalTitle}>Publicação realizada com sucesso!</h1>
              <div className={styles.modalText}>
                <svg
                  width="75px"
                  height="57px"
                  viewBox="0 0 133 133"
                  version="1.1"
                >
                  <g
                    className={styles.checkGroup}
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <circle
                      class={styles.filledCircle}
                      fill="#07b481"
                      cx="66.5"
                      cy="66.5"
                      r="54.5"
                    />
                    <circle
                      class={styles.whiteCircle}
                      fill="#FFFFFF"
                      cx="66.5"
                      cy="66.5"
                      r="55.5"
                    />
                    <circle
                      class={styles.outline}
                      stroke="#07b481"
                      stroke-width="4"
                      cx="66.5"
                      cy="66.5"
                      r="54.5"
                    />
                    <polyline
                      class={styles.check}
                      stroke="#FFFFFF"
                      stroke-width="5.5"
                      points="41 70 56 85 92 49"
                    />
                  </g>
                </svg>
                <p className={styles.modalText}>Seu item foi atualizado</p>
              </div>
              <div className={styles.modalBtns}>
                <button className={styles.modalBtnClose} onClick={closeSucced}>Fechar</button>
              </div>
            </div>
          </div>
        )}
        {isError && (
          <div className={styles.modalOverlay} onClick={closeModal}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <h1 className={styles.modalTitle}>Erro ao atualizar seu item</h1>
              <div className={styles.modalText}>
                <svg
                  width="75px"
                  height="57px"
                  viewBox="0 0 133 133"
                  version="1.1"
                >
                  <g
                    className={styles.failGroup}
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <circle
                      class={styles.filledCircle}
                      fill="#E74C3C"
                      cx="66.5"
                      cy="66.5"
                      r="54.5"
                    />
                    <circle
                      class={styles.whiteCircle}
                      fill="#FFFFFF"
                      cx="66.5"
                      cy="66.5"
                      r="55.5"
                    />
                    <circle
                      class={styles.outline}
                      stroke="#E74C3C"
                      stroke-width="4"
                      cx="66.5"
                      cy="66.5"
                      r="54.5"
                    />
                    <line
                      class={styles.fail}
                      stroke="#FFFFFF"
                      stroke-width="5.5"
                      x1="40"
                      y1="40"
                      x2="90"
                      y2="90"
                    />
                    <line
                      class={styles.fail}
                      stroke="#FFFFFF"
                      stroke-width="5.5"
                      x1="90"
                      y1="40"
                      x2="40"
                      y2="90"
                    />
                  </g>
                </svg>
                <p className={styles.modalText}>Seu item foi atualizado</p>
              </div>
              <div className={styles.modalBtns}>
                <button className={styles.modalBtnClose} onClick={closeSucced}>Fechar</button>
              </div>
            </div>
          </div>
        )}
        <div className={styles.containerExclusion}>
          <div className={styles.containerExclusionHeader}>
            <div>
              <img src={LogoPush} className={styles.containerExclusionIcon} />
              <div className={styles.containerExclusionTitle}>
                <h1 className={styles.containerExclusionTitle}>Rotina de Exclusão</h1>
                <h3 className={styles.containerExclusionSubtitle}>Defina o período de validade dos tokens(Opt-in) por base, os tokens serão excluídos automaticamente conforme a quantidade de dias cadastrados.</h3>
              </div>
            </div>
          </div>
          <section className={`container`}>
            <div className={styles.containerExclusionTable}>
              <table>
                <thead>
                  <tr>
                    <th className={styles.containerExclusionTh}>#</th>
                    <th className={styles.containerExclusionTh}>Base</th>
                    <th className={styles.containerExclusionTh}>Remover tokens com mais de:</th>
                    <th className={styles.containerExclusionTh}>Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {isTokens.map((item) => (
                    <tr key={item.id}>
                      <td><b>{item.id}</b></td>
                      <td>{getLabelFromUrl(item.token.url)}</td>
                      <td>{item.token.prazo} dias</td>
                      <td>
                        <button className={styles.containerExclusionEditBtn} onClick={() => { handleEdit(item) }}>
                          <img src={Edit} className={styles.containerExclusionIcon} alt="Edit Icon" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default WebPushExclusion;
